import React, { useState, useEffect } from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import Link from 'components/link'
import Tooltip from 'components/tooltip'
import PoweredBy from 'components/powered-by'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import { Link as NoAnalyticsLink } from '@cred/react-link'
import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import { Collapse } from 'react-collapse'
import { onlyMobile, exceptMobile } from 'common/visibility'
import config from 'config'
import styles from './styles.scss'
import Disclosures from '../disclosures'

const RateWidgetFooter = ({ theme, footerDisclosure, trackSnowplowEvent }) => {
  const [isOpen, setOpen] = useState(false),
    [hide, setHide] = useState(true),
    partners = ['thebalance1', 'investopedia1', 'yahoo1'],
    hidePartners = ['thebalance1', 'investopedia1', 'homes1'],
    linkCss = partners.includes(theme) ? theme : '',
    showDisclosure = !hidePartners.includes(theme),
    iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

  useEffect(() => {
    setHide(false)
  }, [])

  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclosures',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  return (
    <>
      <Testable className={`${styles.container} mt-24`} testId="footer">
        <div className={styles.links}>
          <div className={styles.row}>
            <Link rel="nofollow" className={`${styles[linkCss]} ${styles.link}`} blank href={`${config.credibleRoot}/terms`} analyticsOptions={{ text: 'Terms' }}>
              <Font type="bodySmall" color="secondary">Terms</Font>
            </Link>
            <Link rel="nofollow" className={`${styles[linkCss]} ${styles.link}`} blank href={`${config.credibleRoot}/privacy`} analyticsOptions={{ text: 'Privacy Policy' }}>
              <Font type="bodySmall" color="secondary">Privacy Policy</Font>
            </Link>
          </div>
          <div className={styles.row}>
            {showDisclosure && (
              <>
                <Link className={`${styles[linkCss]} ${styles.link}`} data-tip data-for="disc-tooltip">
                  <Font type="bodySmall" color="secondary">Advertiser Disclosure</Font>
                </Link>
              </>
            )}
            <NoAnalyticsLink className={styles[linkCss]} data-for="disclosures" onClick={toggleLenderList}>
              <Font type="bodySmall" color="secondary">Disclosures <span className={`cred-icon ${iconClass}`} /></Font>
            </NoAnalyticsLink>
            {!hide && (
              <Tooltip
                id="disc-tooltip"
                className="align-left"
                place="top"
                analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
              >
                <Font type="disclaimer" color="lighter" className={styles.footerDisclosure}>
                  <span>{footerDisclosure}</span>
                </Font>
              </Tooltip>
            )}
          </div>
        </div>
        <PoweredBy className={exceptMobile} useFontAttrs />
      </Testable>

      <Collapse isOpened={isOpen}>
        <Disclosures />
      </Collapse>
      <PoweredBy className={`${onlyMobile} mt-24 align-center`} useFontAttrs />
    </>
  )
}

RateWidgetFooter.propTypes = {
  theme: PropTypes.string,
  footerDisclosure: PropTypes.string,
  trackSnowplowEvent: PropTypes.func.isRequired,
}
RateWidgetFooter.defaultProps = {
  footerDisclosure: "The rates that appear are from companies which Credible receives compensation. This compensation does not impact how or where products appear within the table. The rates and information shown do not include all financial service providers or all of the displayed lender's available services and product offerings.",
}


export { RateWidgetFooter }

export default compose(
  withSnowplowContexts,
)(RateWidgetFooter)
